import React, { useEffect } from 'react';
import { loadStates } from '@/common/api/States.ts';
import { StateData } from '@/common/types';
import { useBadgeMultiSelect } from '@/portal/hooks/useBadgeMultiSelect.ts';
import BadgeMultiSelect from '@/portal/components/BadgeMultiSelect.tsx';

interface StateMultiSelectProps {
  selected: StateData[];
  onChange: (updated: StateData[]) => void;
}

const StateMultiSelect: React.FC<StateMultiSelectProps> = ({
  selected,
  onChange,
}) => {
  const { allItems, selectedItems, toggleItem } =
    useBadgeMultiSelect<StateData>({
      loadAllItems: loadStates,
      initialSelected: selected,
    });

  useEffect(() => {
    onChange(selectedItems);
  }, [selectedItems, onChange]);

  return (
    <BadgeMultiSelect
      label="Licensed States"
      allItems={allItems}
      selectedItems={selectedItems}
      onToggle={toggleItem}
      getId={(s) => s.id}
      getLabel={(s) => s.displayName}
    />
  );
};

export default StateMultiSelect;
